export const filter_worker_invitation_user_types = [
  { label: "Pracownik", value: 0 },
  { label: "Admin", value: 1 },
];
export const worker_invitation_user_types = [
  { label: "Pracownik", value: "User::Worker" },
  { label: "Admin", value: "User::User" },
];

export const getWorkerInvitationUserType = (user_type) =>
  worker_invitation_user_types.find(({ value }) => value === user_type)?.label;
